import { API, graphqlOperation } from 'aws-amplify';
import { listThemes } from 'graphql/queries';
import _ from 'lodash';

const fetchTheme = async () => {
  const apiData = await API.graphql({ query: listThemes });
  return apiData.data.listThemes.items;
};

const fetchSubTheme = async () => {
  const apiData = await API.graphql(graphqlOperation(
    `query GetSubThemes {
        listSubThemes(limit:200) {
          items {
            parentId
            ref
            title
            id
            isSub
            Languages {
              items {
                code
                label
              }
            }
            letters {
              items {
                letters {
                  code
                  condition
                }
              }
            }
          }
        }
      }
      `));
  return apiData.data.listSubThemes.items;
};

const recursiveTheme = (current, themes, subThemes, themeParents) => {
  if (_.isUndefined(current)) return false;
  if (current.isSub) {
    const subThemeDetails = subThemes.find(subTheme => subTheme.id === current.parentId);
    themeParents.unshift(`${subThemeDetails.ref} ${subThemeDetails.title} \n`);
    current = subThemeDetails;
  } else {
    const parent = themes.find(theme => theme.id === current.parentId);
    themeParents.unshift(`${parent.ref} ${parent.name} \n`);
    current = undefined;
  }
  recursiveTheme(current, themes, subThemes, themeParents);
  return themeParents;
};

const getFullThemeName = (subThemeId, themes, subThemes) => {
  const themeParents = [];
  let fullNameTheme = '';
  const subThemeDetails = subThemes.find(subTheme => subTheme.id === subThemeId);
  if (!_.isUndefined(subThemeDetails)) {
    themeParents.push(`${subThemeDetails.ref} ${subThemeDetails.title} `);
    fullNameTheme = recursiveTheme(subThemeDetails, themes, subThemes, themeParents);
  }
  return fullNameTheme;
};

const getFullTheme = (themes, subThemes, theme, subTheme, lasttree = null) => {
  if (lasttree) {
    return getFullThemeName(lasttree, themes, subThemes);
  }
  return getFullThemeName(subTheme, themes, subThemes);
};

export {
  fetchTheme,
  fetchSubTheme,
  getFullThemeName,
  getFullTheme
};
